<template>
  <div class="app-inputstyleswitch">
    <h5>Стиль ввода</h5>
    <div class="flex align-items-center flex-wrap gap-3">
      <div class="flex align-items-center gap-2">
        <RadioButton
          id="input_outlined"
          name="inputstyle"
          value="outlined"
          v-model="inputStyle"
        />
        <label for="input_outlined">Очерченный</label>
      </div>
      <div class="flex align-items-center gap-2">
        <RadioButton
          id="input_filled"
          name="inputstyle"
          value="filled"
          v-model="inputStyle"
        />
        <label for="input_filled">Заполненный</label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance, computed } from 'vue';

const instance = getCurrentInstance();
const appState = instance.proxy.$appState;

const inputStyle = computed({
  get: () => appState.inputStyle,
  set: (value) => {
    appState.inputStyle = value; // this.$appState.inputStyle = value;
  }
});
</script>